import { useCallback, useEffect } from 'react'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { listAttachmentDocumentTypes } from '../use-cases/listAttachmentDocumentTypes'

export function useAttachmentDocumentTypes() {
  const { call, result, status, error } = useAsync(listAttachmentDocumentTypes)
  const abortController = useAbortController([])

  const fetchAttachmentDocumentTypes = useCallback(() => {
    call({ signal: abortController.signal })
  }, [call, abortController])

  useEffect(() => {
    fetchAttachmentDocumentTypes()
  }, [fetchAttachmentDocumentTypes])

  return {
    fetchAttachmentDocumentTypes,
    documentTypes: result || [],
    status,
    error,
  }
}
